import React, { useState } from 'react';
import {  Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useUserTopupComplete } from './api/api';
import moment from 'moment';
import Loader from '../../Loader/buttonLoad';
import { Footer } from '../../../components/footer';
import { useNavigate } from 'react-router-dom';

const TopupComplete = () => {

    const navigate = useNavigate()

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const { data: userTopupcomplete, isLoading } = useUserTopupComplete({
        page,
        size: rowsPerPage,
    })
    const totalPages = Math.ceil(userTopupcomplete?.count / rowsPerPage);

    const handlePageChange = (newPage) => {
        const currentScrollY = window.scrollY;

        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
            window.requestAnimationFrame(() => {
                window.scrollTo(0, currentScrollY);
            });
        }
    };
    return (
        <div>
            <div className="mainContent">
                {(isLoading) && <Loader />}
                <div className="pageContent def-py-30">

                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/master-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Top-Up Completion History</span>
                        </div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div>
                                        <div className="px-4 mb-3">
                                            <div className='row justify-content-between'>
                                                <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                                                    <div className='d-inline-flex g-8 align-items-center'>
                                                        <span className='fs-18 fw-400 text-white-60'>Show</span>
                                                        <div className='form-group mb-0 formInputs gradientBg'>
                                                            <select className='form-control' onChange={(e) => setRowsPerPage(Number(e.target.value))}>
                                                                <option value="10">10</option>
                                                                <option value="30">30</option>
                                                                <option value="50">50</option>
                                                            </select>
                                                        </div>
                                                        <span className='fs-18 fw-400 text-white-60'>entries</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='table-responsive mb-3'>
                                            <table className='table myapptable table-hover table-borderless mb-0'>
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Income</th>
                                                        <th>Date & Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        userTopupcomplete?.data && userTopupcomplete.data.length > 0 ? (
                                                            userTopupcomplete.data.map((v, i) => (
                                                                <tr key={v?._id}>
                                                                    <td>{page * rowsPerPage + (i + 1)}</td>
                                                                    <td>{v?.amount} <span className="text-white-60">USDT</span></td>
                                                                    <td className='pr-4 text-nowrap'>
                                                                        <span>{moment(v.createdAt).format("DD/MM/YYYY | hh:mm A")}</span>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">No data found</td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="px-4">
                                            <div className='row'>
                                                <div className='col-lg-12'>
                                                    <Pagination aria-label="Page navigation" className='customPagination'>

                                                        <PaginationItem disabled={page === 0}>
                                                            <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                                <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                            </PaginationLink>
                                                        </PaginationItem>
                                                        <span className='number'>
                                                            {Array.from({ length: totalPages }, (_, index) => (
                                                                <PaginationItem key={index} active={index === page}>
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                        {index + 1}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            ))}

                                                        </span>

                                                        <PaginationItem disabled={page === totalPages - 1}>
                                                            <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                                Next <i className='bi bi-arrow-right align-bottom'></i>
                                                            </PaginationLink>
                                                        </PaginationItem>
                                                    </Pagination>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default TopupComplete;